import React from 'react';
import { motion } from 'framer-motion';
interface GoldButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function GoldButton({
  children,
  className = '',
  href = 'https://pay.hotmart.com/S104916777P'
}: GoldButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(href, '_blank', 'noopener,noreferrer');
  };
  return <motion.a href={href} onClick={handleClick} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.03,
    boxShadow: '0 0 40px rgba(201, 168, 76, 0.35)'
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-block px-10 py-5 rounded-lg font-body font-bold text-lg
        bg-gradient-to-r from-gold-600 via-gold-400 to-gold-500
        text-navy-900 tracking-wide uppercase
        shadow-lg shadow-gold-500/20
        transition-colors duration-300
        cursor-pointer text-center
        ${className}
      `} role="button" aria-label={typeof children === 'string' ? children : 'Comprar ahora'} data-id="element-102">
      {children}
    </motion.a>;
}